import clsx from 'clsx';
import React from 'react';
import Styles from './BancoDoAuto25BlackBG.css';

function BancoDoAuto25BlackBG({ children, ...props }) {
  return (
    <>
      <section {...props} className={clsx('c2c-black-bg', props.className)}>
        {children}
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BancoDoAuto25BlackBG;
